import styled from "styled-components";

export const StyledCompanyId = styled.h3`
  background-color: ${(props) => props.theme.colors.primary.darkest};
  padding: ${(props) => props.theme.spacing.normal};
  display: inline-block;
  margin-right: auto;
  border-radius: ${(props) => props.theme.radius.normal};
`;
